/*
 * @Description:
 * @Author: yyx
 * @@后台人员: xxx
 * @Date: 2022-09-21 11:28:52
 * @LastEditors: yyx
 * @LastEditTime: 2022-09-21 13:53:36
 */
export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 的高度
    height: null,
    // table 是否为斑马纹
    stripe: true,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: false,
    // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 100,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'carNo',
      label: '车牌号',
      width: '140'
    },
    {
      key: 'createTime',
      label: '创建时间',
      width: '140'
    },
    {
      key: 'action',
      label: '操作',
      width: '140',
      fixed: 'right',
      slot: 'action'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 搜索变量
  const inputList = [
    {
      type: 'input',
      label: '车牌号',
      key: 'carNo',
      placeholder: '请输入',
      labelWidth: 100,
      inputWidth: 200,
      maxlength: 30,
      rules: {
        min: 2,
        max: 8,
        message: '字符长度必须在2-8位之间'
      }
    }
  ]

  // 页面基础变量
  const page = {
    queryForm: {}, // 搜索参数
    total: 0,
    visible: false, // 弹框显示
    title: '新建车牌白名单',
    rowData: null // 单行数据
  }

  return {
    inputList,
    ...page
  }
}
